export default __webpack_public_path__ + "resources/icons/d312-ffe9.png";